import React, { useEffect } from "react";
import styles from "../styles/rights.module.css";
import RightsListGen from "../store/containers/RightsListGenContainer";
import TileType from "../constants/TileType";
import { CircularProgress } from "@mui/material";

const RightsScreen = ({
  rights,
  subrights,
  learnMoresNew,
  fetchRights,
  translationMap,
  isTranslationMapLoading,
}) => {
  useEffect(() => {
    if (Object.keys(translationMap).length !== 0 && rights.length === 0) {
      fetchRights();
    }
    // eslint-disable-next-line
  }, [translationMap]);

  return (
    <div
      className={
        isTranslationMapLoading
          ? styles.mainContainerLoading
          : styles.mainContainer
      }
    >
      {isTranslationMapLoading ? (
        <div className={styles.mainContainerLoading}>
          <CircularProgress style={{ color: "#FC8E56" }} size={100} />
          <p className={styles.loadingTitle}>Fetching Rights Information</p>
          <p className={styles.loadingDescription}>
            We are prepping all of the rights information for editing...
          </p>
        </div>
      ) : (
        <React.Fragment>
          <p className={styles.pageTitle}>Rights Page</p>
          <p className={styles.pageDescription}>
            This page details the rights present on the Workers App. Select "Show Subsection" on a Category to choose that Subsection. Click the "+"
            to add a new Right, Subright, or Learnmore.
          </p>
          <div className={styles.listsContainer}>
            <RightsListGen
              categoryTitle={"Rights Categories"}
              categoryCount={rights.length}
              rightsListData={rights}
              rightsListDataType={TileType.RIGHT}
            />
            <RightsListGen
              categoryTitle={"Subrights Categories"}
              categoryCount={subrights.length}
              rightsListData={subrights}
              rightsListDataType={TileType.SUBRIGHT}
            />
            <RightsListGen
              categoryTitle={"Learn More Categories"}
              categoryCount={learnMoresNew.length}
              rightsListData={learnMoresNew}
              rightsListDataType={TileType.LEARNMORE}
            />
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default RightsScreen;
